import ApplicationController from '../application_controller'

class ChildrenController extends ApplicationController {
  connect () {
    this.cocoonCallbacks()
    this.calcNumberChildren()
    this.toggleChildrenBlock()
  }

  toggleChildrenBlock () {
    if (this.selectChildrenCount() === 0) {
      $('#children_proof_attached_block').addClass('d-none')
      $('#employee_children_proof_attached').prop('checked', false)
    } else {
      $('#children_proof_attached_block').removeClass('d-none')
      $('#employee_children').removeClass('d-none')
    }
    this.toggleBtnAddChild()
    this.toggleFilledChildren()
  }

  toggleFilledChildren () {
    if (this.childrenProofAttachedChecked()) {
      this.addFirstChild()
      this.toggleBtnAddChild()
      $('#employee_children').removeClass('d-none')
      $('#employee_children_alert').addClass('d-none')
    } else {
      $('#employee_children').addClass('d-none')
      this.childrenBlockCount() > 0 && $('#employee_children_alert').removeClass('d-none')
      document.querySelector('.child-block')?.remove()
    }
  }

  toggleBtnAddChild () {
    if (!this.childrenProofAttachedChecked()) return

    const btnAddChild = $('#add_employee_child')
    const hiddenAddBtn = this.childrenBlockCount() >= this.selectChildrenCount()

    if (this.selectChildrenCount() === 0 || hiddenAddBtn) {
      btnAddChild.addClass('d-none')
    } else {
      btnAddChild.removeClass('d-none')
    }
  }

  cocoonCallbacks () {
    $(document).ready(() => {
      $('#employee_children').on('cocoon:after-insert', () => {
        this.toggleBtnAddChild(this.selectChildrenCount())
        this.calcNumberChildren()

        $('.child-block').each(function () {
          window.Forms.initDatePickers(this)
          window.Forms.initFileInputs(this)
          window.Forms.initSelect2(this)
        })
      })
    })
  }

  remove (event) {
    const childBlock = this.parentElementByClass(event.target, 'child-block')
    const existRecord = event.target.dataset.exist

    if (childBlock) {
      existRecord === 'true' ? childBlock.classList.add('d-none') : childBlock.remove()
      this.toggleBtnAddChild(this.selectChildrenCount())
    }
  }

  parentElementByClass (element, className) {
    if (element.classList.contains(className)) {
      return element
    } else {
      return this.parentElementByClass(element.parentElement, className)
    }
  }

  removeUploadedFile (event) {
    const id = event.target.dataset.id
    $(`#file-link-${id}`).addClass('d-none')
    $(`#file-upload-${id}`).removeClass('d-none')
  }

  childrenBlockCount () {
    return $('.child-block').filter(function () {
      return !this.classList.contains('d-none')
    }).length
  }

  addFirstChild () {
    if (this.selectChildrenCount() !== 0 && this.childrenBlockCount() === 0) {
      $('#add_employee_child').click()
    }
  }

  calcNumberChildren () {
    $('.child-block').filter(function () {
      return !this.classList.contains('d-none')
    }).each(function (index) {
      $(this).find('.number-child')[0].innerText = index + 1
    })
  }

  selectChildrenCount () {
    return (parseInt($('#select-children-count').val()) || 0)
  }

  childrenProofAttachedChecked () {
    return $('#employee_children_proof_attached').is(':checked')
  }
}

export default ChildrenController
